var e4 = e4 || {},
    stennevad = stennevad || {};
(function () {
    'use strict';
    jQuery(function () {
        e4.search.loadIndex();
        stennevad.init();
    });
    stennevad.init = function () {
        stennevad.ellipsizeTextBox.init();
        stennevad.ecom.init();
        stennevad.cc.init();
    };
    stennevad.ellipsizeTextBox = {
        init: function () {
            jQuery('.js-e-productlist').on('builded.e4.productlist', function () {
                var jElement = jQuery('.e-products .js-s-products-item-description-container p');
                jElement.each(function () {
                    var wordArray = jQuery( this ).html().split( ' ' );
                    while ( jQuery( this )[ 0 ].scrollHeight > jQuery( this )[ 0 ].offsetHeight ) {
                        wordArray.pop();
                        jQuery( this ).html( wordArray.join( ' ' ) + '...' );
                    }
                });
            } )
        }
    };
    stennevad.cc = {
        init: function () {
            e4.util.require.js( e4.settings.require.jQueryValidate, stennevad.cc.bindEvents );
        },
        bindEvents: function () {
            jQuery( '.js-e-cc-list-products-form' ).on( 'input', '.js-stennevad-variant-matrix-quanitity', e4.util.debounce( function ( event ) {
                stennevad.ecom.coli.validate( event.target );
            }, 500 ) ).on( 'click', '.js-stennevad-variant-matrix-quantifier', function () {
                var newQuantity = stennevad.ecom.coli.quantifier( this, '.js-e-cc-list-product', '.js-stennevad-variant-matrix-quanitity', false );
                jQuery( this ).closest( '.js-e-cc-list-product' ).find( '.js-stennevad-variant-matrix-quanitity' ).val( newQuantity ).trigger( 'input' );
            } );
        }
    };
    stennevad.ecom = {
        data: {},
        init: function () {
            stennevad.ecom.getData();
            stennevad.ecom.bindEvents();
            stennevad.ecom.cart.init();
            stennevad.ecom.productlist.init();
            stennevad.ecom.carousel.related();
            e4.util.require.js(e4.settings.require.handlebars, function () {
                    if (jQuery('.js-product-image-carousel-handlebars-container').length === 1) {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-product-image-carousel #js-e-handlebars-tmpl-product-image-carousel-thumbs #js-e-handlebars-tmpl-product-image-carousel-modal #js-e-handlebars-tmpl-product-image-carousel-modal-thumbs' );
                        stennevad.ecom.carousel.build(stennevad.ecom.getDefaultSelectedColorVariant());
                    }
                e4.handlebars.registerHelpers('compare replace_in_str');
                if (jQuery('.js-stennevad-image-color-select').length === 1) {
                    e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-product-image-color-selector');
                    stennevad.ecom.variantColorImage.init();
                }
                if (jQuery('.js-stennevad-variant-matrix').length === 1) {
                    stennevad.ecom.event = e4.util.registerEvents('matrixBuild matrixBuilded favoritesBuild favoritesBuilded', 'matrix');
                    e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-variant-matrix');
                    e4.handlebars.registerPartials('#js-e-handlebars-partial-variant-matrix-favorites');
                    stennevad.ecom.variantMatrix.init();
                }
            });
        },
        utils: {
            roundUp: function ( intQuantity, intColi ) {
                return Math.ceil( ( intQuantity + 1 ) / intColi ) * intColi;
            }
        },
        getData: function () {
            stennevad.ecom.data = window.stennevadVariantData || {};
        },
        getDefaultSelectedColorVariant: function () {
            var defaultVariant = {};
            jQuery.each( stennevad.ecom.data.variantoptions, function ( index, obj ) {
                defaultVariant = obj.filter( function ( option ) {
                    return option.isSelected === true;
                } )[ 0 ];
                defaultVariant = defaultVariant !== undefined ? defaultVariant : obj[ 0 ];
            } );

            if ( stennevad.ecom.data.variantcombinations.length ) {
                return stennevad.ecom.data.variantcombinations.filter( function ( obj ) {
                    return obj.variantID === defaultVariant.value;
                } )[ 0 ];
            }
            else {
                return stennevad.ecom.data.product;
            }
        },
        bindEvents: function () {
            jQuery( '.js-e-product-form-addtocart ' ).on( 'click', '.js-stennevad-variant-matrix-quantifier', function () {
                var newQuantity = stennevad.ecom.coli.quantifier( this, '.js-e-product-form-addtocart', '.js-stennevad-variant-matrix-quanitity', true );
                jQuery( this ).closest( '.js-e-product-form-addtocart' ).find( '.js-stennevad-variant-matrix-quanitity' ).val( newQuantity ).trigger( 'input' );
            } );
        },
        productlist: {
            init: function () {
                stennevad.ecom.productlist.bindEvents();
            },
            bindEvents: function () {
                jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function () {
                    if ( 'IntersectionObserver' in window ) {
                        stennevad.ecom.productlist.stickyHeader();
                    }

                } );
            },
            stickyHeader: function () {
                var observer = new IntersectionObserver( function ( entries ) {
                    entries.forEach( function ( entry ) {
                        if ( entry.isIntersecting === true ) {
                            jQuery( '.js-sticky-product-filters-header' ).hide();
                        }
                        else {
                            jQuery( '.js-sticky-product-filters-header' ).removeClass( 'd-none' ).fadeIn();

                        }
                    } );
                }, { threshold: .95 } );
                observer.observe( document.querySelector( '.js-e-productslist-header' ) );

            }
        },
        coli: {
            showInMatrix: function () {
                var hasColi = stennevad.ecom.data.variantcombinations.filter( function ( obj ) {
                    return obj.orderMultiple > 0;
                } ).length > 0;
                if ( hasColi === true ) {
                    jQuery( '.js-stennevad-matrix-header-coli' ).removeClass( 'd-none' );
                }
            },
            validate: function ( domElm ) {
                var intColi = parseInt( jQuery( domElm ).data( 'coli' ) ),
                    intQuantity = parseInt( jQuery( domElm ).val() );
                if ( isNaN( intColi ) === false && isNaN( intQuantity ) === false && intColi > 0 && intQuantity > 0 ) {
                    if ( intQuantity % intColi !== 0 ) {
                        jQuery( domElm ).val( stennevad.ecom.utils.roundUp( intQuantity, intColi ) )
                    };
                }
            },
            quantifier: function ( domElm, strForm, strQuantity, boolMinCheck ) {
                var jThis = jQuery( domElm ),
                    jForm = jThis.closest( strForm ),
                    quantifier = jThis.data( 'quantifier' ),
                    jQuantity = jForm.find( strQuantity ),
                    rules = {
                        min: parseInt( jQuantity.data( 'ruleMin' ) ) || 0,
                        step: parseInt( jQuantity.data( 'step' ) ) || 1
                    },
                    currentQuantity = parseInt( jQuantity.val() );
                quantifier === 'increase' ? currentQuantity += rules.step : currentQuantity -= rules.step;
                if ( boolMinCheck === false ) {
                    rules.min = 0;
                }
                if ( currentQuantity < rules.min ) {
                    currentQuantity = rules.min;
                }
                return currentQuantity;
            }
        },
        carousel: {
            build: function (imageData) {
                if (imageData !== undefined) {
                    jQuery('.js-product-image-carousel-handlebars-container').html(e4.handlebars.tmpl.productImageCarousel(imageData));
                    jQuery('.js-product-image-carousel-thumbs-handlebars-container').html(e4.handlebars.tmpl.productImageCarouselThumbs(imageData));
                }
                jQuery('.js-product-image-carousel-model-handlebars-container').html(e4.handlebars.tmpl.productImageCarouselModal(imageData));
                jQuery('.js-product-image-carousel-modal-thumbs-handlebars-container').html(e4.handlebars.tmpl.productImageCarouselModalThumbs(imageData));

                // ✅ Robust fallback – uden arrow functions
                requestAnimationFrame(function () {
                    setTimeout(function () {
                            jQuery('.js-product-image-carousel-handlebars-container .carousel-item img').each(function (index) {
                                jQuery(this).attr('data-slide-to', index);
                            });
                            jQuery('.js-product-image-carousel-thumbs-handlebars-container li').each(function (index) {
                                jQuery(this).attr('data-slide-to', index);
                            });
                        console.log('🛠 Fallback applied – data-slide-to re-set');
                    }, 500);
                    });
            },
            related: function () {
                jQuery('.js-stennevad-related-carousel').each(function (index, domElm) {
                    var jCarousel = jQuery(domElm);
                    jCarousel.on('slide.bs.carousel', function (event) {
                        var jNextSlide = jQuery(event.relatedTarget),
                            intNextSlideIndex = jNextSlide.index(),
                            intItemsPerSlide = 4,
                            intTotalItems = jCarousel.find('.carousel-item').length;

                        if (intNextSlideIndex >= intTotalItems - (intItemsPerSlide - 1)) {
                            var intItemsToSlide = intItemsPerSlide - (intTotalItems - intNextSlideIndex);
                            for (var i = 0; i < intItemsToSlide; i++) {
                                if (event.direction === 'left') {
                                    jCarousel.find('.carousel-item').eq(i).appendTo('.carousel-inner');
                                } else {
                                    jCarousel.find('.carousel-item').eq(0).appendTo('.carousel-inner');
                                }
                            }
                        }
                    });
                });
            }
        },
        
        
        variantColorImage: {
            init: function () {
                stennevad.ecom.variantColorImage.build();
                stennevad.ecom.variantColorImage.bindEvents();
            },
            bindEvents: function () {
                jQuery( '.js-stennevad-image-color-select' ).on( 'change', '.js-selected-color-name-select', function ( event ) {
                    var selectedValue = jQuery( event.target ).find( 'option:selected' );
                    var imageObj = stennevad.ecom.variantColorImage.image.get( selectedValue.data( 'variantId' ) );
                    stennevad.ecom.carousel.build( imageObj );
                } );
            },
            image: {
                get: function ( variantID ) {
                    return stennevad.ecom.data.variantcombinations.filter( function ( obj ) {
                        return obj.variantID.indexOf( variantID ) > -1;
                    } )[ 0 ];
                }
            },
            colors: {
                get: function () {
                    var returnArr = [];
                    jQuery.each( stennevad.ecom.data.variantoptions, function ( key, arr ) {
                        if ( key.toLowerCase().indexOf( 'color' ) > -1 || key.toLowerCase().indexOf( 'farve' ) > -1 ) {
                            for ( var i = 0; i < arr.length; i++ ) {
                                returnArr.push( arr[ i ] );
                            }
                        }
                    } );
                    return returnArr;
                }
            },
            build: function () {
                var colorOptions = stennevad.ecom.variantColorImage.colors.get();
                console.log("🎨 colorOptions:", colorOptions);
                jQuery('.js-stennevad-image-color-select').html(e4.handlebars.tmpl.productImageColorSelector(colorOptions));
            }
        },
        variantMatrix: {
            init: function () {
                jQuery( '.js-stennevad-variant-matrix' ).trigger( stennevad.ecom.event.matrixBuild );
                stennevad.ecom.coli.showInMatrix();
                stennevad.ecom.variantMatrix.bindEvents();
                stennevad.ecom.variantMatrix.build();

            },
            bindEvents: function () {
                jQuery( '.js-stennevad-variant-matrix' ).on( 'matrixBuilded.e4.matrix', function () {
                    e4.util.require.js( e4.settings.require.jQueryValidate, e4.product.bindEvents );
                    stennevad.ecom.variantMatrix.favorites.loadFavoritesInList();
                } ).on( 'favoritesBuilded.e4.matrix', function () {
                    stennevad.ecom.variantMatrix.favorites.bindEvents();
                } ).on( 'input', '.js-stennevad-variant-matrix-quanitity', e4.util.debounce( function ( event ) {
                    stennevad.ecom.coli.validate( event.target );
                }, 500 ) ).on( 'change', '.js-e-cc-list', function () {
                    if ( jQuery( this ).closest( '.js-e-product-cc-list-form' ).find( '.js-e-cc-list' ).filter( ':checked' ).length > 0 ) {
                        jQuery( this ).closest( '.js-stennevad-variant-matrix-favorite-dropdown' ).addClass( 'is-added' );
                    }
                    else {
                        jQuery( this ).closest( '.js-stennevad-variant-matrix-favorite-dropdown' ).removeClass( 'is-added' );
                    }
                } ).on( 'click', '.js-stennevad-variant-matrix-quantifier', function () {
                    var newQuantity = stennevad.ecom.coli.quantifier( this, '.js-e-product-form', '.js-stennevad-variant-matrix-quanitity', true );
                    jQuery( this ).closest( '.js-e-product-form' ).find( '.js-stennevad-variant-matrix-quanitity' ).val( newQuantity ).trigger( 'input' );
                } );
            },
            build: function () {
                var variantColText = '';
                stennevad.ecom.data.variantcombinations.forEach( function ( combo ) {
                    combo.option = {};
                    jQuery.each( stennevad.ecom.data.variantoptions, function ( key, option ) {
                        if ( variantColText === '' ) {
                            variantColText = key;
                        }
                        combo.option.value = option.filter( function ( obj ) {
                            return obj.id === combo.variantID;
                        } )[ 0 ].name;

                    } );
                } );
                var buildObj = {
                    combos: stennevad.ecom.data.variantcombinations
                };

                jQuery( '.js-stennevad-variant-matrix' ).html( e4.handlebars.tmpl.variantMatrix( buildObj ) );
                jQuery( '.js-stennevad-matrix-header-variant' ).html( variantColText );
                jQuery( '.js-stennevad-variant-matrix' ).trigger( 'matrixBuilded.e4.matrix' );
            },
            favorites: {
                bindEvents: function () {
                    if ( jQuery( '.js-stennevad-variant-matrix' ).length === 1 ) {
                        jQuery( document ).on( 'submit', '.js-e-product-cc-list-form', function ( event ) {
                            event.preventDefault();
                        } ).on( 'change', '.js-e-cc-list', function ( event ) {
                            stennevad.ecom.variantMatrix.favorites.toggleList( event.target );
                        } );
                    }
                },
                toggleList: function ( domInput ) {
                    var jInput = jQuery( domInput );
                    if ( jInput.prop( 'checked' ) === true ) {
                        stennevad.ecom.variantMatrix.favorites.addToList( jInput );
                    }
                    else {
                        stennevad.ecom.variantMatrix.favorites.removeFromList( jInput );
                    }
                },
                addToList: function ( jInput ) {
                    var variantId = jInput.closest( '.js-stennevad-variant-matrix-favorites' ).data( 'variantId' );
                    var inputArr = jInput.data( 'urlAdd' ).split( '&' );
                    var dataObj = {};
                    for ( var i = 1; i < inputArr.length; i++ ) {
                        var key = inputArr[ i ].split( '=' )[ 0 ];
                        var value = inputArr[ i ].split( '=' )[ 1 ];
                        dataObj[ key ] = key.indexOf( 'VariantID' ) === -1 ? value : variantId;
                    }
                    //dataObj.redirect = 'False';
                    jQuery.ajax( {
                        url: '/system/data/favorites',
                        method: 'POST',
                        data: dataObj
                    } );
                },
                removeFromList: function ( jInput ) {
                    var variantId = jInput.closest( '.js-stennevad-variant-matrix-favorites' ).data( 'variantId' );
                    var inputArr = jInput.data( 'urlRemove' ).split( '&' );
                    var dataObj = {};
                    for ( var i = 1; i < inputArr.length; i++ ) {
                        var key = inputArr[ i ].split( '=' )[ 0 ];
                        var value = inputArr[ i ].split( '=' )[ 1 ];
                        dataObj[ key ] = key.indexOf( 'VariantID' ) === -1 ? value : variantId;
                    }
                    dataObj[ 'redirect' ] = false;
                    //dataObj.redirect = 'False';
                    jQuery.ajax( {
                        url: '/system/data/favorites',
                        method: 'POST',
                        data: dataObj
                    } );
                },
                loadFavoritesInList: function () {
                    jQuery( '.js-stennevad-variant-matrix' ).trigger( 'favoritesBuild.e4.matrix' );
                    jQuery.ajax( {
                        url: '/system/data/favorites',
                        method: 'GET'
                    } ).done( function ( data ) {
                        stennevad.ecom.data.favorites = data;
                        jQuery.each( stennevad.ecom.data.favorites.lists, function ( index, list ) {
                            stennevad.ecom.data.favoritesActions.filter( function ( obj ) {
                                list.isInList = false;
                                if ( list.id === obj.id ) {
                                    list.addAction = obj.addAction;
                                    list.removeAction = obj.removeAction;
                                }
                            } );
                            if ( list.products.length > 0 ) {
                                jQuery.each( stennevad.ecom.data.variantcombinations, function ( index, combo ) {
                                    combo.isInList = list.products.filter( function ( prod ) {
                                        //console.log( prod.id === combo.productID );
                                        return ( prod.variantId === combo.variantID && prod.id === combo.productID );
                                    } ).length > 0;
                                } );
                            }
                        } );
                        jQuery( '.js-stennevad-variant-matrix-favorites' ).html( e4.handlebars.partial.variantMatrixFavorites( stennevad.ecom.data.favorites ) );
                        stennevad.ecom.variantMatrix.favorites.updateFavoritesInList();

                    } )
                },
                updateFavoritesInList: function () {
                    jQuery( '.js-stennevad-variant-matrix' ).find( '.js-e-cc-list' ).each( function () {
                        var jThis = jQuery( this ),
                            productID = jThis.closest( '.js-stennevad-variant-matrix-favorites' ).data( 'productId' ),
                            variantID = jThis.closest( '.js-stennevad-variant-matrix-favorites' ).data( 'variantId' ),
                            variantCombo = stennevad.ecom.data.variantcombinations.filter( function ( obj ) {
                                return ( obj.variantID === variantID && obj.productID === productID );
                            } )[ 0 ];
                        jQuery.each( stennevad.ecom.data.favorites.lists, function ( index, list ) {
                            if ( list.products.length > 0 ) {
                                variantCombo.isInList = list.products.filter( function ( prod ) {
                                    return ( prod.variantId === variantCombo.variantID && prod.id === variantCombo.productID );
                                } ).length > 0;

                            }
                        } );
                        if ( variantCombo.isInList === true ) {
                            jThis.closest( '.js-stennevad-variant-matrix-favorite-dropdown' ).addClass( 'is-added' );
                            jThis.prop( 'checked', true );
                        }
                    } );
                    jQuery( '.js-stennevad-variant-matrix' ).trigger( 'favoritesBuilded.e4.matrix' );
                }
            }
        },
        cart: {
            init: function () {
                stennevad.ecom.cart.bindEvents();
            },
            bindEvents: function () {
                jQuery( '.js-e-cart-orderlines' ).on( 'input', '.js-e-orderline-quantity-input', e4.util.debounce( function ( event ) {
                    stennevad.ecom.coli.validate( event.target );
                }, 500 ) ).on( 'click', '.js-e-orderline-quantity-input-quantifier', function () {
                    var newQuantity = stennevad.ecom.coli.quantifier( this, '.js-e-orderline', '.js-e-orderline-quantity-input', true );
                    jQuery( this ).closest( '.js-e-orderline' ).find( '.js-e-orderline-quantity-input' ).val( newQuantity ).trigger( 'input' );
                } );
            }
        }
    };
}() );
